<template>
  <div class="barechart" ref="chart"></div>
</template>
<script>
export default {
  name: "BarEchart",
  props: {
    chartData: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      chartInstance: null,
      resizeHandler: null,
      option: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          show: false,
          top: 0,
          textStyle: {
            color: "#ffffff"
          }
        },
        grid: {
          top: 24,
          left: 50,
          right: 30,
          bottom: 40
        },
        xAxis: {
          type: "category",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(53,189,219,0.4)",
              width: 0.8,
              type: "solid"
            }
          },
          data: []
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(53,189,219,0.4)",
              width: 0.8,
              type: "solid"
            }
          }
        },
        series: [
          {
            name: "",
            data: [],
            barMaxWidth: 30,
            type: "bar",
            itemStyle: {
              normal: {
                color: function(params) {
                  return {
                    colorStops: [
                      {
                        offset: 0,
                        color: "#00ffff"
                      }, //柱图渐变色
                      {
                        offset: 0.5,
                        color: "#00c0f9"
                      }, //柱图渐变色
                      {
                        offset: 1,
                        color: "#00aff8"
                      }
                    ]
                  };
                }
              },
              emphasis: {
                color: function(params) {
                  return {
                    colorStops: [
                      {
                        offset: 0,
                        color: "#00aff8"
                      }, //柱图高亮渐变色
                      {
                        offset: 0.7,
                        color: "#00c0f9"
                      }, //柱图高亮渐变色
                      {
                        offset: 1,
                        color: "#00ffff"
                      } //柱图高亮渐变色
                    ]
                  };
                }
              }
            }
          }
        ]
      }
    };
  },
  methods: {
    getDefaultSeries(name, data) {
      return {
        name: name || "",
        data: data || [],
        barMaxWidth: 30,
        type: "bar",
        itemStyle: {
          normal: {
            color: function(params) {
              return {
                colorStops: [
                  {
                    offset: 0,
                    color: "#00ffff"
                  },
                  {
                    offset: 0.5,
                    color: "#00c0f9"
                  },
                  {
                    offset: 1,
                    color: "#00aff8"
                  }
                ]
              };
            }
          },
          emphasis: {
            color: function(params) {
              return {
                colorStops: [
                  {
                    offset: 0,
                    color: "#00aff8"
                  },
                  {
                    offset: 0.7,
                    color: "#00c0f9"
                  },
                  {
                    offset: 1,
                    color: "#00ffff"
                  }
                ]
              };
            }
          }
        }
      };
    },
    getSeriesColor(chartData, index) {
      const colors = chartData.colors || ["#3ddc97", "#4dabf7", "#ffd166", "#f25f5c", "#b388ff"];
      return colors[index % colors.length];
    },
    drawLineGraph(chartData) {
      if (!this.chartInstance) {
        this.chartInstance = this.$echarts.init(this.$refs.chart);
      }
      const series = chartData.series || [];
      this.option.xAxis.data = chartData.xvalue || [];
      if (series.length) {
        this.option.legend.show = true;
        this.option.legend.data = series.map(item => item.name);
        this.option.grid.top = 42;
        this.option.series = series.map((item, index) => {
          return {
            name: item.name,
            data: item.data || [],
            barMaxWidth: 28,
            type: "bar",
            itemStyle: {
              normal: {
                color: item.color || this.getSeriesColor(chartData, index)
              }
            }
          };
        });
      } else {
        this.option.legend.show = false;
        this.option.grid.top = 24;
        this.option.series = [this.getDefaultSeries(chartData.name, chartData.data)];
      }
      this.chartInstance.setOption(this.option, true);
      if (!this.resizeHandler) {
        this.resizeHandler = () => {
          if (this.chartInstance) {
            this.chartInstance.resize();
          }
        };
        window.addEventListener("resize", this.resizeHandler);
      }
    }
  },
  mounted() {
    this.drawLineGraph(this.chartData);
  },
  beforeDestroy() {
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
      this.resizeHandler = null;
    }
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.barechart {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/echarts/barEchart.vue